import { RootState } from '@next/core-lib/app';

/**
 * Branding state for the application.
 * Stores the active tenant name to enable tenant-specific theming and styling.
 */
export interface BrandingState extends RootState {
  /** The name of the active tenant (e.g., 'Agravis', 'Agrifirm') */
  tenantName: string;
}

export class BrandingLogoSrc {
  public static readonly PoultryNextLogo = '/assets/images/poultry-next-logo.svg';
  public static readonly AgravisLogo = '/assets/images/agravis-avidata.svg';
}
